import styled from 'styled-components';

import { adSlotConfig } from '../../ad-slot-config';
import { useDefineSlot } from '../../hooks/use-define-slot';

const AdContainer = styled.div`
  min-height: 250px;
  max-height: 300px;
  margin: 0 auto;
`;

export const DisplayAdStartpageLeaderboard: React.FC<{ refresh: boolean }> = ({
  refresh,
}) => {
  const slotConfig = adSlotConfig.Startpage.Leaderboard;
  useDefineSlot({ ...slotConfig, refresh });

  return <AdContainer id={slotConfig.id} />;
};
